import * as Sentry from "@sentry/react";
import { api } from "creso-core/api";
import { AxiosResponse, AxiosError } from "axios";
import { isFeatureEnabled } from "@/utils/feature-flags";
import { APIError, ErrorData } from "web-core/utils";

function getErrorTitle(error: AxiosError<{ error: ErrorData }>) {
  return error.response?.data?.error?.message ?? "An unknown error has occured";
}

export function initApp(options: {
  onUnauthorisedRequest?: () => Promise<void>;
}) {
  if (isFeatureEnabled("enableSentry")) {
    Sentry.init({
      dsn: "https://d43e704f9610add0912841af8aa9b07a@o4509308457779200.ingest.us.sentry.io/4509309653942272",
      sendDefaultPii: true,
    });
  }
  api.interceptors.response.use(
    (response: AxiosResponse) => response.data,
    (error: AxiosError<{ error: ErrorData }>) => {
      if (error.status === 401) {
        options?.onUnauthorisedRequest?.();
      }
      return Promise.reject(
        new APIError(
          error.status ?? 400,
          getErrorTitle(error),
          error.response?.data?.error as ErrorData
        )
      );
    }
  );
}
